const SITE_URL = "https://kredytpodkarpacie.pl";

const LOGO_URL = `${SITE_URL}/favicon.svg`;
const OG_IMAGE = `${SITE_URL}/images/expert-kredytowy-og.jpg`;

export const webSiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE_URL}/#website`,
  name: "EXPERT KREDYTOWY",
  url: SITE_URL,
  inLanguage: "pl-PL",
  publisher: { "@id": `${SITE_URL}/#organization` },
};

export const homeSchema = {
  "@context": "https://schema.org",
  "@type": "FinancialService",
  "@id": `${SITE_URL}/#organization`,
  name: "EXPERT KREDYTOWY",
  alternateName: "Jan Wojdyła – Ekspert Kredytowy i Finansowy",
  description:
    "Profesjonalna i niezależna analiza kredytowa w Sanoku i na całym Podkarpaciu. Kredyty hipoteczne, gotówkowe i firmowe — współpraca z ponad 20 bankami, ponad 25 lat doświadczenia w finansach. Bezpłatna pierwsza konsultacja.",
  image: OG_IMAGE,
  logo: LOGO_URL,
  url: SITE_URL,
  hasMap: "https://www.google.com/maps/search/?api=1&query=ul.+Dworcowa+11A,+38-500+Sanok",
  telephone: "+48698084044",
  email: "biuro@kredytpodkarpacie.pl",
  foundingDate: "1999",
  address: {
    "@type": "PostalAddress",
    streetAddress: "ul. Dworcowa 11A",
    addressLocality: "Sanok",
    postalCode: "38-500",
    addressRegion: "Podkarpackie",
    addressCountry: "PL",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: "49.5540110",
    longitude: "22.2119271",
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "09:00",
      closes: "17:00",
    },
  ],
  priceRange: "Bezpłatna pierwsza konsultacja",
  areaServed: [
    { "@type": "City", name: "Sanok" },
    { "@type": "City", name: "Brzozów" },
    { "@type": "City", name: "Lesko" },
    { "@type": "City", name: "Ustrzyki Dolne" },
    { "@type": "City", name: "Dynów" },
    { "@type": "City", name: "Krosno" },
    { "@type": "AdministrativeArea", name: "Bieszczady" },
    { "@type": "AdministrativeArea", name: "Podkarpacie" },
  ],
  sameAs: [SITE_URL],
  founder: {
    "@type": "Person",
    name: "Jan Wojdyła",
    jobTitle: "Broker finansowy i ekspert kredytowy",
  },
  knowsAbout: [
    "kredyty hipoteczne",
    "kredyty gotówkowe",
    "kredyty firmowe",
    "refinansowanie kredytów",
    "zdolność kredytowa",
    "analiza ofert bankowych",
    "usługi finansowe Expert Kredytowy",
  ],
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Usługi eksperta kredytowego",
    itemListElement: [
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Kredyty hipoteczne",
          description: "Pomoc w uzyskaniu kredytu na mieszkanie lub dom — porównanie ofert wielu banków.",
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Kredyty gotówkowe",
          description: "Dobór najkorzystniejszego kredytu gotówkowego do sytuacji klienta.",
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Kredyty firmowe",
          description: "Finansowanie dla firm — kredyty obrotowe i inwestycyjne.",
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Bezpłatna analiza kondycji finansowej",
          description: "Anonimowy analizator online — wynik w 60 sekund.",
        },
      },
    ],
  },
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+48698084044",
    contactType: "customer service",
    availableLanguage: "Polish",
    areaServed: ["Sanok", "Brzozów", "Lesko", "Ustrzyki Dolne", "Dynów", "Bieszczady", "Podkarpacie"],
  },
};

export const personSchema = {
  "@context": "https://schema.org",
  "@type": "Person",
  name: "Jan Wojdyła",
  jobTitle: "Niezależny Ekspert Kredytowy i Finansowy",
  description:
    "Niezależny ekspert kredytowy z ponad 25-letnim doświadczeniem w branży bankowej i finansowej. Założyciel marki EXPERT KREDYTOWY.",
  image: "https://storage.readdy-site.link/project_files/4e257fdf-86c3-45fa-9fad-66a82fd8796b/093aca7f-e4f0-48e1-b20a-e152c70c9620_compressed_janek.webp",
  url: `${SITE_URL}/o-mnie`,
  sameAs: [SITE_URL],
  worksFor: {
    "@type": "Organization",
    name: "EXPERT KREDYTOWY",
    url: SITE_URL,
  },
  address: {
    "@type": "PostalAddress",
    addressLocality: "Sanok",
    addressRegion: "Podkarpackie",
    addressCountry: "PL",
  },
  knowsAbout: [
    "Kredyty hipoteczne",
    "Kredyty gotówkowe",
    "Kredyty firmowe",
    "Refinansowanie",
    "Konsolidacja zobowiązań",
    "Analiza finansowa",
    "Leasing",
    "Analiza zdolności kredytowej",
  ],
  alumniOf: {
    "@type": "EducationalOrganization",
    name: "Wyższa Szkoła Bankowa w Rzeszowie",
  },
};

export const offerSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  name: "Kompleksowa analiza kredytowa dla osób prywatnych",
  description:
    "Niezależna analiza kredytowa – kredyty hipoteczne, gotówkowe, refinansowanie, analiza finansowa i ubezpieczenia kredytowe. Analiza wielu ofert bankowych.",
  provider: {
    "@type": "LocalBusiness",
    name: "EXPERT KREDYTOWY",
    url: SITE_URL,
    image: OG_IMAGE,
  },
  areaServed: {
    "@type": "GeoCircle",
    geoMidpoint: {
      "@type": "GeoCoordinates",
      latitude: "49.5540110",
      longitude: "22.2119271",
    },
    geoRadius: "100 km",
  },
  serviceType: "Analiza kredytowa i finansowa",
  offers: {
    "@type": "Offer",
    price: "0",
    priceCurrency: "PLN",
    description: "Bezpłatna pierwsza konsultacja",
  },
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Usługi dla osób prywatnych",
    itemListElement: [
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Kredyty hipoteczne",
          description:
            "Finansowanie zakupu, budowy lub remontu nieruchomości – mieszkania, domy, działki.",
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Kredyty gotówkowe",
          description:
            "Szybkie kredyty na dowolny cel – remont, wyjazd, spłatę zobowiązań.",
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Refinansowanie",
          description:
            "Przejście na korzystniejsze warunki spłaty kredytu hipotecznego.",
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Analiza finansowa",
          description:
            "Kompleksowa analiza sytuacji finansowej, planowanie budżetu, optymalizacja zobowiązań.",
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Ubezpieczenia kredytowe",
          description:
            "Dobór odpowiedniego ubezpieczenia życia i zdrowia do kredytu.",
        },
      },
    ],
  },
};

export const dlaFirmSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  name: "Finansowanie dla przedsiębiorców",
  description:
    "Kompleksowe wsparcie finansowe dla firm – kredyty inwestycyjne, obrotowe, leasing, refinansowanie firmowe, kredyty na start i gwarancje bankowe.",
  provider: {
    "@type": "LocalBusiness",
    name: "EXPERT KREDYTOWY",
    url: SITE_URL,
    image: OG_IMAGE,
  },
  areaServed: {
    "@type": "GeoCircle",
    geoMidpoint: {
      "@type": "GeoCoordinates",
      latitude: "49.5540110",
      longitude: "22.2119271",
    },
    geoRadius: "100 km",
  },
  serviceType: "Analiza kredytowa dla firm",
  offers: {
    "@type": "Offer",
    price: "0",
    priceCurrency: "PLN",
    description: "Bezpłatna pierwsza konsultacja",
  },
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Usługi dla firm",
    itemListElement: [
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Kredyty inwestycyjne",
          description:
            "Finansowanie zakupu maszyn, urządzeń, budynków i innych inwestycji.",
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Kredyty obrotowe",
          description:
            "Elastyczne finansowanie bieżącej działalności firmy i płynności finansowej.",
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Leasing",
          description:
            "Leasing operacyjny i finansowy dla firm – samochody, maszyny, sprzęt IT.",
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Refinansowanie firmowe",
          description:
            "Przejście na korzystniejsze warunki spłaty istniejących zobowiązań.",
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Kredyty na start",
          description:
            "Finansowanie dla nowych firm i startupów z programów wsparcia przedsiębiorczości.",
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Gwarancje bankowe",
          description:
            "Pomoc w uzyskaniu gwarancji bankowych dla przetargów i kontraktów.",
        },
      },
    ],
  },
};

export const howToSchema = {
  "@context": "https://schema.org",
  "@type": "HowTo",
  name: "Proces współpracy z ekspertem kredytowym",
  description:
    "Transparentny proces współpracy od pierwszej konsultacji do podpisania umowy kredytowej. 6 kroków do najlepszego finansowania.",
  step: [
    {
      "@type": "HowToStep",
      position: 1,
      name: "Bezpłatna konsultacja",
      text: "Poznaję Twoją sytuację, cele i oczekiwania. Rozmowa może odbyć się osobiście w Sanoku, telefonicznie lub online.",
    },
    {
      "@type": "HowToStep",
      position: 2,
      name: "Analiza ofert",
      text: "Przeszukuję i porównuję oferty wielu banków i instytucji finansowych.",
    },
    {
      "@type": "HowToStep",
      position: 3,
      name: "Rekomendacja i wyjaśnienie",
      text: "Przedstawiam wybrane rozwiązanie – warunki, koszty, harmonogram i wszystkie szczegóły.",
    },
    {
      "@type": "HowToStep",
      position: 4,
      name: "Przygotowanie dokumentów",
      text: "Wspieram w kompletowaniu i przygotowaniu całej dokumentacji wymaganej przez bank.",
    },
    {
      "@type": "HowToStep",
      position: 5,
      name: "Wniosek i decyzja",
      text: "Składam wniosek w Twoim imieniu i śledzę proces aż do decyzji kredytowej.",
    },
    {
      "@type": "HowToStep",
      position: 6,
      name: "Podpisanie umowy",
      text: "Pomagam w formalnym zakończeniu procesu – umowa, notariusz, wypłata środków.",
    },
  ],
  totalTime: "P2W",
};

export const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "Czy korzystanie z usług eksperta kredytowego jest płatne?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Pierwsza konsultacja jest zawsze bezpłatna i niezobowiązująca. Ekspert kredytowy otrzymuje prowizję od banku w przypadku pozytywnego zakończenia procesu kredytowego, co oznacza, że klient nie ponosi bezpośrednich kosztów korzystania z usług.",
      },
    },
    {
      "@type": "Question",
      name: "Jakie dokumenty są potrzebne do wniosku kredytowego?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Podstawowe dokumenty to dowód osobisty, zaświadczenie o dochodach, dokumenty dotyczące nieruchomości (w przypadku kredytu hipotecznego) oraz potwierdzenie zatrudnienia. Dokładna lista zależy od rodzaju kredytu i sytuacji klienta.",
      },
    },
    {
      "@type": "Question",
      name: "Ile trwa proces uzyskania kredytu hipotecznego?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Czas zależy od banku i złożoności sytuacji. W przypadku kredytów hipotecznych proces zazwyczaj trwa od 2 do 6 tygodni od momentu złożenia kompletnego wniosku do wypłaty środków.",
      },
    },
    {
      "@type": "Question",
      name: "Czy mogę skonsolidować kilka kredytów w jeden?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Tak, konsolidacja kredytów to jedna z oferowanych usług. Polega ona na zastąpieniu kilku miesięcznych rat jedną, zazwyczaj niższą ratą.",
      },
    },
    {
      "@type": "Question",
      name: "Czy ekspert kredytowy reprezentuje konkretny bank?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Nie – jako niezależny ekspert kredytowy współpracuję z wieloma bankami i instytucjami finansowymi, co pozwala znaleźć rozwiązanie najlepiej dopasowane do klienta.",
      },
    },
    {
      "@type": "Question",
      name: "Obsługujecie klientów spoza Sanoka?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Tak, obsługuję klientów z całego województwa podkarpackiego – Brzozów, Lesko, Krosno, Ustrzyki Dolne, Dynów, Zagórz, Bieszczady oraz okoliczne miejscowości. Konsultacje mogą odbywać się telefonicznie lub online.",
      },
    },
  ],
};

export const analizaSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: "Analiza kondycji finansowej – EXPERT KREDYTOWY",
  description:
    "Sprawdź swoją kondycję finansową w 60 sekund. Bezpłatny analizator finansowy – oszczędności, poduszka bezpieczeństwa, inwestycje i zabezpieczenie na przyszłość.",
  url: `${SITE_URL}/analiza`,
  isPartOf: {
    "@type": "WebSite",
    name: "EXPERT KREDYTOWY",
    url: SITE_URL,
  },
};

export const kontaktSchema = {
  "@context": "https://schema.org",
  "@type": "ContactPage",
  name: "Kontakt – EXPERT KREDYTOWY",
  description:
    "Skontaktuj się z ekspertem kredytowym Janem Wojdyłą. Bezpłatna konsultacja kredytowa w Sanoku i na Podkarpaciu. Telefon, e-mail, formularz kontaktowy.",
  url: `${SITE_URL}/kontakt`,
  mainEntity: {
    "@type": "LocalBusiness",
    name: "EXPERT KREDYTOWY",
    telephone: "+48698084044",
    email: "biuro@kredytpodkarpacie.pl",
    address: {
      "@type": "PostalAddress",
      streetAddress: "ul. Dworcowa 11A",
      addressLocality: "Sanok",
      postalCode: "38-500",
      addressRegion: "Podkarpackie",
      addressCountry: "PL",
    },
    image: OG_IMAGE,
    url: SITE_URL,
  },
};
